class CartDrawer extends HTMLElement {
  constructor() {
    super()

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    )
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    )
    this.setHeaderCartIconAccessibility()
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble")
    cartLink.setAttribute("role", "button")
    cartLink.setAttribute("aria-haspopup", "dialog")
    cartLink.addEventListener("click", (event) => {
      event.preventDefault()
      this.open(cartLink)
    })
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault()
        this.open(cartLink)
      }
    })
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy)
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary')
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote)
    // here the animation doesn't seem to always get triggered. A timeout seem to help

    setTimeout(() => {
      this.classList.add("animate", "active")
    })

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains(
          "is-empty"
        )
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer")
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close")
        trapFocus(containerToTrapFocusOn, focusElement)
      },
      {once: true}
    )

    document.querySelector("html").classList.add("overflow-hidden")
    this.custom()
  }

  custom() {
    this.slider()

    const itemCart = document.querySelectorAll(".js-cart-item")

    const idCart = [...itemCart].map((element) => {
      return +element.getAttribute("data-cart-id")
    })

    /* progress bar */

    this.progressBar()
    const progressValues = document.querySelector(".js-progress-values")
    let idGift = +progressValues.getAttribute("data-id")
    const totalAmount = +progressValues.getAttribute("data-total")
    const freeGiftPoint = +progressValues.getAttribute("data-gift")

    itemCart.forEach((element) => {
      const cartId = +element.getAttribute("data-cart-id")

      if (idGift === cartId) {
        element.classList.add("free-gift")
      }
    })

    setTimeout(async () => {
      if (totalAmount >= freeGiftPoint) {
        /* add Gift */
        if (!idCart.includes(idGift)) {
          this.addFreeGift(idGift)
        } else {
          fetch(window.Shopify.routes.root + "?sections=cart-drawer")
            .then((res) => res.json())
            .then((res) => {
              const sectionElements =
                document.querySelector("#CartDrawer")

              sectionElements.innerHTML =
                this.getSectionInnerHTML(
                  res["cart-drawer"],
                  "#CartDrawer"
                )
            })
            .finally(() => {
              this.slider()
              this.progressBar()
              const itemCart =
                document.querySelectorAll(".js-cart-item")
              const progressValues = document.querySelector(
                ".js-progress-values"
              )
              const idGift =
                +progressValues.getAttribute("data-id")
              itemCart.forEach((element) => {
                const cartId =
                  +element.getAttribute("data-cart-id")
                if (idGift === cartId) {
                  element.classList.add("free-gift")
                }
              })
            })
        }
      } else {
        console.log("idGift", idGift)
        this.removeFreeGift(idGift)
      }
    }, 2)
  }

  slider() {
    const swiperWrapper = document.querySelector(".js-swiper-wrapper")
    const cartFrequently = document.querySelector(".js-cart-frequently")
    if (swiperWrapper && swiperWrapper.childElementCount === 0) {
      cartFrequently.classList.add("hidden")
    }
    const swiperNext = document.querySelector(".js-button-next")
    const swiperPrev = document.querySelector(".js-button-prev")
    new Swiper(".js-swiper-frequently", {
      speed: 400,
      loop: true,
      spaceBetween: 20,
      slidesPerView: 1,
      navigation: {
        nextEl: swiperNext,
        prevEl: swiperPrev,
      },
    })
  }

  progressBar() {
    const progressBar = document.querySelector(".js-progress-bar");
    const progressBarTitle = document.querySelector('.js-drawer-progress-title');
    const progressBarFree = document.querySelector(".js-progress-bar-free");
    const progressValues = document.querySelector(".js-progress-values");
    const valuesShipping = document.querySelectorAll(".js-values-shipping");
    const valuesGift = document.querySelectorAll(".js-values-gift");
    const footerShipping = document.querySelector(".js-total_shipping");


    // points
    const totalAmount = +progressValues.getAttribute("data-total")
    const freeShippingPoint = +progressValues.getAttribute("data-shipping")
    const freeGiftPoint = +progressValues.getAttribute("data-gift")

    // %
    let progress = (totalAmount / freeShippingPoint) * 100
    let progressFree = 0

    progress = Math.min(100, Math.max(0, progress))

    if (totalAmount >= freeShippingPoint) {
      progressFree =
        ((totalAmount - freeShippingPoint) /
          (freeGiftPoint - freeShippingPoint)) *
        100
      progressFree = Math.min(100, Math.max(0, progressFree))
    }

    progressBar.style.width = progress + "%"
    progressBarFree.style.width = progressFree + "%"

    valuesShipping.forEach((element) => {
      element.classList.remove("active")
    })

    progressBar.classList.remove("active")

    valuesGift.forEach((element) => {
      element.classList.remove("active")
    })

    setTimeout(() => {
      if (totalAmount >= freeShippingPoint) {
        valuesShipping.forEach((element) => {
          element.classList.add("active");
        })

        progressBarTitle.innerHTML = "🎉 Congrats! You've unlocked <strong>FREE SHIPPING!</strong>"
        progressBar.classList.add("active")
        footerShipping?.classList.add("active")
      }

      if (totalAmount >= freeGiftPoint) {
        valuesGift.forEach((element) => {
          element.classList.add("active")
        })
      }
    }, 2)
  }

  addFreeGift(idGift) {
    const formData = {
      items: [
        {
          id: parseInt(idGift),
          quantity: 1,
        },
      ],
    }

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .catch(() => {
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors")
        errors.textContent = window.cartStrings.error
      })
      .finally(() => {
        fetch(window.Shopify.routes.root + "?sections=cart-drawer")
          .then((res) => res.json())
          .then((res) => {
            const sectionElements =
              document.querySelector("#CartDrawer")

            sectionElements.innerHTML = this.getSectionInnerHTML(
              res["cart-drawer"],
              "#CartDrawer"
            )
          })
          .finally(() => {
            this.slider()
            this.progressBar()
            const itemCart =
              document.querySelectorAll(".js-cart-item")
            const progressValues = document.querySelector(
              ".js-progress-values"
            )
            const idGift = +progressValues.getAttribute("data-id")

            const itemBubble = document.querySelector(
              ".cart-count-bubble span:first-child"
            )
            const count = +progressValues.getAttribute("data-count")
            itemBubble.textContent = count

            itemCart.forEach((element) => {
              const cartId = +element.getAttribute("data-cart-id")
              if (idGift === cartId) {
                element.classList.add("free-gift")
              }
            })
          })
      })
  }

  removeFreeGift(idGift) {
    const formData = {
      updates: {
        [parseInt(idGift)]: 0,
      },
    }

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .catch(() => {
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors")
        errors.textContent = window.cartStrings.error
      })
      .finally(() => {
        fetch(window.Shopify.routes.root + "?sections=cart-drawer")
          .then((res) => res.json())
          .then((res) => {
            const sectionElements =
              document.querySelector("#CartDrawer")

            sectionElements.innerHTML = this.getSectionInnerHTML(
              res["cart-drawer"],
              "#CartDrawer"
            )
          })
          .finally(() => {
            const itemCart =
              document.querySelectorAll(".js-cart-item")
            const cartDrawer =
              document.querySelector("cart-drawer.drawer")

            const cartBubble =
              document.querySelector(".cart-count-bubble")

            const progressValues = document.querySelector(
              ".js-progress-values"
            )
            const totalAmount =
              +progressValues.getAttribute("data-total")

            this.slider()
            this.progressBar()

            const idGift = +progressValues.getAttribute("data-id")
            itemCart.forEach((element) => {
              const cartId = +element.getAttribute("data-cart-id")
              if (idGift === cartId) {
                element.classList.add("free-gift")
              }
            })
            setTimeout(() => {
              if (document.querySelector("cart-drawer-items").classList.contains('is-empty')) {
                cartDrawer.classList.add("is-empty")
                if (cartBubble) {
                  textContent = 0
                }
              } else {
                const itemBubble = document.querySelector(
                  ".cart-count-bubble span:first-child"
                )
                const count =
                  +progressValues.getAttribute("data-count")
                itemBubble.textContent = count
              }
            }, 1)
          })
      })
  }

  close() {
    this.classList.remove("active")
    removeTrapFocus(this.activeElement)
    document.querySelector("html").classList.remove("overflow-hidden")
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button")
    cartDrawerNote.setAttribute("aria-expanded", "false")

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      )
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      )
    })

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape)
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
    this.querySelector(".drawer__inner").classList.remove("is-empty")
    this.productId = parsedState.id
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id)
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      )
    })

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      )
      this.open()
    })
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ]
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector)
  }

  setActiveElement(element) {
    this.activeElement = element
  }
}

customElements.define("cart-drawer", CartDrawer)

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ]
  }
}

customElements.define("cart-drawer-items", CartDrawerItems)
